import { TableOfContents } from "docx";
import {
  generateSectionParagraphs,
  getSectionHeader,
} from "../utils/WordExportUtils";
import { blueColour, defaultFontNormal } from "../utils/styling";
export const getTableOfContents = () => {
  const paragraphs = [
    {
      segments: [
        {
          text: "[To update the page numbers displayed in the Table of Contents, right-click on the table and select ‘Update Table of Contents’ (in Sharepoint) or ‘Update Field’ (in Excel).]",
          font: defaultFontNormal,
          color: blueColour,
          break: 1,
        },
      ],
    },
  ];

  return [
    getSectionHeader("Table of Contents", false, 2),
    new TableOfContents("Table of Contents", {
      hyperlink: true,
      headingStyleRange: "1-5",
    }),
    ...generateSectionParagraphs(paragraphs),
  ];
};
